<template>
  <div class="display one-component-detail-admin">
    <div class="title-component-admin">Hiển thị</div>
    <el-form :model="data" class="p-3">
      <el-row type="flex">
        <el-radio v-model="data.status" label="public">Public</el-radio>
        <el-radio v-model="data.status" label="private">Private</el-radio>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Display',
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped></style>
